module.exports = __webpack_public_path__ + "img/order-info.37d2ab2f.png";